import axios from 'axios'
import PriceConfig from '@/dto/price_config/PriceConfig'
import PriceConfigItem from '@/dto/price_config/PriceConfigItem'

const PriceConfigService = {
  loadPriceConfigs(): Promise<PriceConfig[]> {
    return axios
      .get(`/admin/price-weight-grids`)
      .then(response => response.data.grids)
  },

  savePriceConfig(config: PriceConfig) {
    const request =
      config.id !== null
        ? axios.put(`/admin/price-weight-grids/${config.id}`, config)
        : axios.post('/admin/price-weight-grids', config)

    return request.then(response => response.data.grid)
  },

  deletePriceConfig(priceConfigId: number) {
    return axios.delete(`/admin/price-weight-grids/${priceConfigId}`)
  },

  getPriceConfigItems(priceConfigId: number): Promise<PriceConfigItem[]> {
    return axios
      .get(`/admin/price-weight-grids/${priceConfigId}/items`)
      .then(response => response.data.gridItems)
  },

  savePriceConfigItems(
    priceConfigId: number,
    items: PriceConfigItem[]
  ): Promise<PriceConfigItem[]> {
    return axios
      .put(`/admin/price-weight-grids/${priceConfigId}/items`, { items })
      .then(response => response.data.items)
  },
}

export default PriceConfigService
